module.exports = new __parcel__URL__("shop_machines_aic_lab.e8e7557b.png").toString();